import { render, staticRenderFns } from "./OnlineUsersLocal.vue?vue&type=template&id=a2bd8fb6&scoped=true&lang=pug"
import script from "./OnlineUsersLocal.vue?vue&type=script&lang=js"
export * from "./OnlineUsersLocal.vue?vue&type=script&lang=js"
import style0 from "./OnlineUsersLocal.vue?vue&type=style&index=0&id=a2bd8fb6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bd8fb6",
  null
  
)

export default component.exports